import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { IBillingShippingModel } from "../../../interfaces/LicenseModel";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { Console } from "console";
import { AdalService } from "../../../shared/adal.service";
import { Router } from "@angular/router";

@Component({
    selector:'generate-glt-license',
    template:require('./generate-glt-license.component.html'),
    styles:[require('./generate-glt-license.component.css')]
})
export class GenerateGltLicenseComponent{
    gltGenerateKeyForm:FormGroup
    dialogTitle="Add/Edit License";
    errorMessage="";
    isSaveButtonDisabled=true;
    submitted=false;
    activatedYearsArray=[0, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    licenseKey='';
    error='';
    isGenerateKeyButtonClicked=false;
    isBillingShippingDetailFetched=false;
    gltLicenseDisplayData=[];
    shouldFetchSalesOrderNo=true;
    SelectedLicenseDetail;
    isLicensekeyGenerated=false;
    prevSalesOrderNo='';
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    constructor(
        public dialogRef:MdDialogRef<GenerateGltLicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.gltLicenseDisplayData=this.dialogData.gltLicenseData;
        this.SelectedLicenseDetail=this.dialogData.SelectedLicenseDetail;
        if(this.SelectedLicenseDetail){
            console.log(this.SelectedLicenseDetail);
            this.gltGenerateKeyForm.patchValue({
                'UniqueHardwareId':this.SelectedLicenseDetail.CustomerUniqueKey,
                'TabletSerial':this.SelectedLicenseDetail.TabletSerialNo,
                'NoOfYearsActivated':this.SelectedLicenseDetail.WarrantyYears,
                'SalesOrderNo':this.SelectedLicenseDetail.SalesOrderNo
            })
            this.licenseKey=this.SelectedLicenseDetail.LicenseKey;
            this.isBillingShippingDetailFetched=true;
            this.isLicensekeyGenerated=true;
            this.prevSalesOrderNo=this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName=this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedLicenseDetail.ShipToState;
        }

    }
    buildForm(){
        this.gltGenerateKeyForm=this.formBuilder.group({
            'UniqueHardwareId':['',Validators.required],
            'TabletSerial':['',Validators.required],
            'NoOfYearsActivated':[],
            'SalesOrderNo':['',Validators.required]
        })
    }
    fetchBillingShippingDetails(){
        this.appLoader.open()
        this.licenseService.getBillingShippingDetail(this.gltGenerateKeyForm.value.SalesOrderNo).subscribe((data)=>{
            console.log(data);
            if(!data.IsError && data.DataObject!=null){
                this.billingShippingDetail=data.DataObject;
                this.isBillingShippingDetailFetched=true;
                this.errorMessage='';
                this.appLoader.close();
            }
            else{
                this.errorMessage=data.Error;
                this.appLoader.close();
            }
        })
    }
    generateGltLicenseKey(){
        let model={
            TabletSerial:this.gltGenerateKeyForm.value.TabletSerial,
            DeviceUniqueId:this.gltGenerateKeyForm.value.UniqueHardwareId
        }
        this.appLoader.open()
        this.licenseService.generateGltLicenseKey(model).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.errorMessage=''
                if(this.SelectedLicenseDetail!=null){
                    this.SelectedLicenseDetail.TabletSerialNo=this.gltGenerateKeyForm.value.TabletSerial;
                    this.SelectedLicenseDetail.CustomerUniqueKey=this.gltGenerateKeyForm.value.UniqueHardwareId;
                }
                this.licenseKey=data.DataObject;
                this.isLicensekeyGenerated=true;
            }
            else{
                this.errorMessage='Cannot generate license key'
            }
            this.appLoader.close()
        })
    }
    fetchSalesOrderDetailAndGenerateKey(){
        this.isGenerateKeyButtonClicked=true;
        if(!this.gltGenerateKeyForm.valid){
            return;
        }
        else{
            //fetch the sales order details
            if(!this.isBillingShippingDetailFetched && this.shouldFetchSalesOrderNo && !this.isLicensekeyGenerated){
                let model={
                    TabletSerial:this.gltGenerateKeyForm.value.TabletSerial,
                    DeviceUniqueId:this.gltGenerateKeyForm.value.UniqueHardwareId
                }
                this.appLoader.open()
                this.licenseService.generateGltLicenseKey(model).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.errorMessage=''
                        if(this.SelectedLicenseDetail!=null){
                            this.SelectedLicenseDetail.TabletSerialNo=this.gltGenerateKeyForm.value.TabletSerial;
                            this.SelectedLicenseDetail.CustomerUniqueKey=this.gltGenerateKeyForm.value.UniqueHardwareId;
                        }
                        this.licenseKey=data.DataObject;
                        this.isLicensekeyGenerated=true;
                        this.licenseService.getBillingShippingDetail(this.gltGenerateKeyForm.value.SalesOrderNo).subscribe((data)=>{
                            console.log(data);
                            if(!data.IsError && data.DataObject!=null){
                                this.billingShippingDetail=data.DataObject;
                                this.isBillingShippingDetailFetched=true;
                                this.errorMessage='';
                                this.appLoader.close();
                            }
                            else{
                                this.errorMessage=data.Error;
                                this.appLoader.close();
                            }
                        })
                    }
                    else{
                        this.errorMessage='Cannot generate license key'
                        this.appLoader.close()
                    }
                   
                })
            }
            else if(!this.isBillingShippingDetailFetched && this.shouldFetchSalesOrderNo){
                this.fetchBillingShippingDetails();
            }
            else if(!this.isLicensekeyGenerated){
                //call the generate license key api
                this.generateGltLicenseKey();
            }
        }
    }
    checkSalesOrderNo(){
        if(this.prevSalesOrderNo != null){
            if(this.prevSalesOrderNo.trim().toUpperCase()==this.gltGenerateKeyForm.value.SalesOrderNo.trim().toUpperCase()){
                return;
            }
        }
        this.prevSalesOrderNo=this.gltGenerateKeyForm.value.SalesOrderNo;
        if(this.gltLicenseDisplayData){
            return this.gltLicenseDisplayData.forEach(element => {
                if(this.gltGenerateKeyForm.value.SalesOrderNo != null){
                    if(this.gltGenerateKeyForm.value.SalesOrderNo.toUpperCase()==element.SalesOrderNo.toUpperCase()){
                        Swal.fire({
                            title:"This sales order no already exists",
                            text:"Are you sure you want to use this Sales Order No?",
                            showCancelButton:true,
                            showCloseButton:true,
                            showConfirmButton:true,
                            confirmButtonText:"Yes",
                            confirmButtonColor:"#FFCA28",
                            cancelButtonText:"No",
                        }).then((result)=>{
                            if(result.isConfirmed){
                                this.shouldFetchSalesOrderNo=true;
                                this.isBillingShippingDetailFetched=false;
                               this.fetchBillingShippingDetails();
    
                            }
                            else{
                                this.shouldFetchSalesOrderNo=false;
                                this.isBillingShippingDetailFetched=false;
                                this.gltGenerateKeyForm.patchValue({
                                    SalesOrderNo:""
                                });
                            }
                        })
                    }
                    else{
                        this.shouldFetchSalesOrderNo=true;
                        this.isBillingShippingDetailFetched=false;
                    }
                }
            });
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }
    }
    onSave(){
            this.submitted=true;
            this.appLoader.open();
            if(!this.isBillingShippingDetailFetched && !this.isLicensekeyGenerated){
                Swal.fire({
                    title:'Billing Shipping Details not fetched and License Key not generated/updated',
                    text:'Please fetch billing shipping details and generate License Key by clicking on the "Generate Key" button.',
                    confirmButtonColor:'#FFCA28',
                    focusConfirm:false,
                    allowEnterKey:false
                })
                this.appLoader.close()
                return;
            }
            else if(!this.isBillingShippingDetailFetched){
                Swal.fire({
                                title:'Billing shipping details not fetched',
                                text:'Please fetch billing shipping details by clicking on the "Generate Key" button.',
                                confirmButtonColor:'#FFCA28',
                                focusConfirm:false,
                                allowEnterKey:false
                            })
                this.appLoader.close()
                return;
            }
            else if(!this.isLicensekeyGenerated){
                Swal.fire({
                    title:'License key not generated or updated.',
                    text:'Changes made in the field Unique H/W Id or Tablet Serial Number requires the generation of license key.Please generate license key by clicking on the "Generate Key" button.',
                    confirmButtonColor:'#FFCA28',
                    focusConfirm:false,
                    allowEnterKey:false
                })
                this.appLoader.close()
                return;
            }
            if(this.SelectedLicenseDetail!=null){ //Edit License
                if(this.SelectedLicenseDetail.SalesOrderNo.toUpperCase()!=this.gltGenerateKeyForm.value.SalesOrderNo.toUpperCase()){ //If SalesOrderNo has been changed then add the new sales order in the database
                    this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            let model={
                                LicenseId:this.SelectedLicenseDetail.LicenseId,
                                LicenseKey:this.licenseKey,
                                TabletSerialNo:this.gltGenerateKeyForm.value.TabletSerial,
                                CustomerUniqueKey:this.gltGenerateKeyForm.value.UniqueHardwareId,
                                CustomerId:data.DataObject.CustomerId,
                                SalesOrderNo:this.gltGenerateKeyForm.value.SalesOrderNo,
                                ShippingAddressId:data.DataObject.ShippingAddressId,
                                WarrantyYears:this.gltGenerateKeyForm.value.NoOfYearsActivated,
                                ApplicationIdentification:"A",
                                PartNo:'931-00000-01',
                                CreatedBy:Number(localStorage.getItem('userid')),
                                UpdatedBy:Number(localStorage.getItem('userid'))
                            }
                            this.licenseService.updateGltLicense(model).subscribe((licenseData)=>{
                                if(!licenseData.IsError && licenseData.DataObject!=null){
                                    this.gltLicenseDisplayData=licenseData.DataObject;
                                    this.appLoader.close();
                                    this.dialogRef.close(this.gltLicenseDisplayData);
                                }
                                else{
                                    this.error=licenseData.Error;
                                    this.appLoader.close();
                                    this.dialogRef.close(this.gltLicenseDisplayData);
                                }
                            })
                        }
                    })
                }
                else{
                    let model={
                        LicenseId:this.SelectedLicenseDetail.LicenseId,
                        LicenseKey:this.licenseKey,
                        TabletSerialNo:this.gltGenerateKeyForm.value.TabletSerial,
                        CustomerUniqueKey:this.gltGenerateKeyForm.value.UniqueHardwareId,
                        CustomerId:this.SelectedLicenseDetail.CustomerId,
                        SalesOrderNo:this.gltGenerateKeyForm.value.SalesOrderNo,
                        ShippingAddressId:this.SelectedLicenseDetail.ShippingAddressId,
                        WarrantyYears:this.gltGenerateKeyForm.value.NoOfYearsActivated,
                        ApplicationIdentification:"A",
                        PartNo:'931-00000-01',
                        CreatedBy:Number(localStorage.getItem('userid')),
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    this.licenseService.updateGltLicense(model).subscribe((licenseData)=>{
                        if(!licenseData.IsError && licenseData.DataObject!=null){
                            this.gltLicenseDisplayData=licenseData.DataObject;
                            this.appLoader.close();
                            this.dialogRef.close(this.gltLicenseDisplayData);
                        }
                        else{
                            this.error=licenseData.Error;
                            this.appLoader.close();
                            this.dialogRef.close(this.gltLicenseDisplayData);
                        }
                    })
                }
            }
            else{ //Add License
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        let model={
                            LicenseKey:this.licenseKey,
                            TabletSerialNo:this.gltGenerateKeyForm.value.TabletSerial,
                            CustomerUniqueKey:this.gltGenerateKeyForm.value.UniqueHardwareId,
                            CustomerId:data.DataObject.CustomerId,
                            SalesOrderNo:this.gltGenerateKeyForm.value.SalesOrderNo,
                            ShippingAddressId:data.DataObject.ShippingAddressId,
                            WarrantyYears:this.gltGenerateKeyForm.value.NoOfYearsActivated,
                            ApplicationIdentification:"A",
                            PartNo:'931-00000-01',
                            CreatedBy:Number(localStorage.getItem('userid')),
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.generateGltLicense(model).subscribe((licenseData)=>{
                            if(!licenseData.IsError && licenseData.DataObject!=null){
                                this.gltLicenseDisplayData=licenseData.DataObject;
                                this.appLoader.close();
                                this.dialogRef.close(this.gltLicenseDisplayData);
                            }
                            else{
                                this.error=licenseData.Error;
                                this.appLoader.close();
                                this.dialogRef.close(this.gltLicenseDisplayData);
                            }
                        })
                    }
                })
            }
    }
    onCancel(){
        this.dialogRef.close(this.gltLicenseDisplayData);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/glt/generate-glt-license/generate-glt-license.component.ts